import { useEffect } from "react";

/**
 * Sets the document title and meta description for a page.
 * Restores the site-wide defaults from index.html on unmount so
 * SPA navigation between pages doesn't leak stale metadata.
 */
export function usePageMeta(title: string, description?: string) {
  useEffect(() => {
    const previousTitle = document.title;
    const descriptionTag = document.querySelector('meta[name="description"]');
    const previousDescription = descriptionTag?.getAttribute("content") ?? null;

    document.title = title;
    if (description && descriptionTag) {
      descriptionTag.setAttribute("content", description);
    }

    return () => {
      document.title = previousTitle;
      if (previousDescription !== null && descriptionTag) {
        descriptionTag.setAttribute("content", previousDescription);
      }
    };
  }, [title, description]);
}
